import { APP_PLATFORM_VERSION } from '@semios/app-platform-version'
import { setWithQuotaRecovery } from 'utils/storageQuota/setWithQuotaRecovery'
import type { TPersistentStoreName } from '../persistenceStoresCleanUpMap'

/** Never rejects: it runs from a store subscription with nowhere to propagate a failure to */
export const persistStoreState = async (
  storeName: TPersistentStoreName,
  state: Record<string, unknown>,
): Promise<void> => {
  await setWithQuotaRecovery(
    storeName,
    { ...state, storeVersion: APP_PLATFORM_VERSION, timestamp: Date.now() },
    { persistentStoreName: storeName, storageOperation: 'persistStoreState' },
  )
}
